// @flow

import React from 'react';
import './style.less';

type TProps = {
    children?: any,
    className?: string | Object,
    size?: 'small' | 'middle' | 'big' | 'scale',
    theme?: 'black' | 'white' | 'blue' | 'yellow' | 'light-blue' | 'dark-blue' | 'red' | 'gray' | 'normal-blue',
};

const GameText = ({children, theme = 'white', size = 'middle', className, ...rest}: TProps) => {
    return (
        <span className={`game-text game-text_theme_${theme} game-text_size_${size} ${className ? className : ''}`} {...rest}>
            {children}
        </span>
    );
};

export {GameText};
